import { render } from "./GeoAeroporti.vue?vue&type=template&id=8bcece16"
import script from "./GeoAeroporti.vue?vue&type=script&lang=js"
export * from "./GeoAeroporti.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__